
const SubscribeModel = () => {

    return(
        <div className="modal fade login-model" id="subscribeModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                            <ul className="list-unstyled steps-list">
                                <li className="step-name active-step">معلومات عن البطاقة</li>
                                <li className="step-name">تأكيد الدفع</li>
                            </ul>
                        <form>
                            <div className="form-steps">
                                <div className="form-step form-active-step">
                                    <div className="form-group cassandra-form-group">
                                        <label>حامل البطاقة</label>
                                        <input className="form-control cassandra-form-control"  type="text" placeholder="حامل البطاقة" />
                                    </div>
                                    <div className="form-group cassandra-form-group">
                                        <label>رقم البطاقة</label>
                                        <input className="form-control cassandra-form-control" type="password" placeholder="رقم البطاقة" />
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group cassandra-form-group">
                                                <label>تاريخ الإنتهاء</label>
                                                <input className="form-control cassandra-form-control"  type="password" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group cassandra-form-group">
                                                <label>&nbsp;</label>
                                                <input className="form-control cassandra-form-control"   type="password"  placeholder=""/>
                                            </div>
                                        </div>
                                        <div className="col-md-5 mr-auto">
                                            <div className="form-group cassandra-form-group">
                                                <label>CVC</label>
                                                <input  className="form-control cassandra-form-control"  type="password"  placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <button className="form-step-next submit-btn" type="button"> إدفع الأن </button>
                                    </div>
                                </div>
                                <div className="form-step ">
                                    <div className="form-group cassandra-form-group">
                                        <label>حامل البطاقة</label>
                                        <input className="form-control cassandra-form-control"  type="text" placeholder="حامل البطاقة" />
                                    </div>
                                    <div className="form-group cassandra-form-group">
                                        <label>رقم البطاقة</label>
                                        <input className="form-control cassandra-form-control" type="password" placeholder="رقم البطاقة" />
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group cassandra-form-group">
                                                <label>تاريخ الإنتهاء</label>
                                                <input className="form-control cassandra-form-control"  type="password" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group cassandra-form-group">
                                                <label>&nbsp;</label>
                                                <input className="form-control cassandra-form-control"   type="password"  placeholder=""/>
                                            </div>
                                        </div>
                                        <div className="col-md-5 mr-auto">
                                            <div className="form-group cassandra-form-group">
                                                <label>CVC</label>
                                                <input  className="form-control cassandra-form-control"  type="password"  placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <input className="submit-btn"  type="submit" value="اتمام الدفع"  />
                                    </div>
                                </div>       
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );

};
export default SubscribeModel;
